import {useMutation} from "@tanstack/react-query";
import {SortGtaRateRequest} from "@/Stub/V1";
import {processValidationErrors} from "@/Util/Api/processValidationErrors";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export const useSortGtaRate = () => useMutation({
    mutationFn: async (data: SortGtaRateRequest) => {
        try {
            return await GtaRatesApiClient.sortGtaRate(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});
